import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";
import { Entity } from "@backstage/catalog-model";
import { ROUTE_DISPLAY_METADATA } from "./hooks";

import { rootRouteRef } from "./routes";

export const routeDisplayPlugin = createPlugin({
  id: "route-display",
  routes: {
    root: rootRouteRef,
  },
});

export const RouteDisplayPage = routeDisplayPlugin.provide(
  createRoutableExtension({
    name: "routeDisplayPage",
    component: () =>
      import("./components/RouteDisplayPage").then((m) => m.RouteDisplayPage),
    mountPoint: rootRouteRef,
  })
);

export const routeDisplayAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[ROUTE_DISPLAY_METADATA]);
